export default function (is) {
    return function (value) {
        return (!!value || value === 0) && value === is
    }
}
